import jwtDecode from 'jwt-decode';

export class jwtUtils {
  static isAuth(token: string) {
    if (!token) {
      return false;
    }
    const decoded: any = jwtDecode(token);
    // console.log(decoded);
    if (decoded.exp > new Date().getTime() / 1000) {
      return true;
    } else {
      return false;
    }
  }

  static getId(token: string) {
    const decoded: any = jwtDecode(token);
    return decoded.jti;
  }

  static getName(token: string) {
    const decoded: any = jwtDecode(token);
    return decoded.subject;
  }

  static getRoles(token: string) {
    const decoded: any = jwtDecode(token);
    return decoded.roles;
  }
}
